import { nestApiClient } from './api-client';
import { UserInfoResponse } from '@wwe-portal/entities/user.type';

export const getUserInfo = () => {
  return nestApiClient.get<UserInfoResponse>('/user/v2/info');
};

export const viewUserWebTutorial = () => {
  return nestApiClient.put('/user/v2/web-tutorial-status');
};

export const viewSuperstarTutorial = () => {
  return nestApiClient.put('/user/v2/superstar-tutorial-status');
};

export const updatePlayerAvatar = ({ avatarId }) => {
  return nestApiClient.put('/user/v2/avatars', { avatarId });
};

export const updatePlayerAvatarFrame = ({ frameId }: { frameId: number }) => {
  return nestApiClient.put('/user/v2/frames', { frameId });
};

export const removePlayerAvatarFrame = () => {
  return nestApiClient.delete('/user/v2/frames');
};

export const getUserExperiments = () => {
  return nestApiClient.get<{ data: Record<string, unknown> }>(
    '/user/v2/experiments'
  );
};

export const getUserFeatureConfigs = () => {
  return nestApiClient.post<{ data: Record<string, Record<string, unknown>> }>(
    '/user/v2/feature-configs',
    { abAttributes: {} }
  );
};
